import { Instagram, MessageCircle } from "lucide-react";
import { toast } from "sonner";

const btn = "flex-1 py-3 rounded-full font-semibold flex items-center justify-center gap-2 text-sm transition-colors duration-200";

export const ShareButtons = ({ event }) => {
  const url = `${process.env.REACT_APP_BACKEND_URL}/api/share/${event.id}`;
  const text = `${event.title} · ${event.neighborhood} — scoperto su WYD`;

  const shareWhatsApp = () => {
    window.open(`https://wa.me/?text=${encodeURIComponent(`${text}\n${url}`)}`, "_blank", "noopener");
  };

  const shareNative = async () => {
    if (navigator.share) {
      try { await navigator.share({ title: event.title, text, url }); } catch {}
      return;
    }
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copiato: incollalo su Instagram");
    } catch { toast.error("Impossibile copiare il link"); }
  };

  return (
    <div>
      <div className="overline text-wyd-muted mb-2">Condividi</div>
      <div className="flex gap-2">
        <button data-testid="share-whatsapp-btn" onClick={shareWhatsApp}
          className={`${btn} bg-[#25D366]/15 text-wyd-accent hover:bg-[#25D366]/30`}>
          <MessageCircle size={16} /> WhatsApp
        </button>
        <button data-testid="share-instagram-btn" onClick={shareNative}
          className={`${btn} bg-wyd-accent/15 text-wyd-accent-soft hover:bg-wyd-accent/30`}>
          <Instagram size={16} /> Instagram
        </button>
      </div>
    </div>
  );
};
